import React, { useCallback, useEffect, useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import NavbarComp from "../../shared/components/Navbar";
import { IoAddCircleOutline } from "react-icons/io5";
import { useAuth } from "../auth/hooks/useAuth";
import AlertMessage from "../../shared/components/Alert";
import CustomerTable from "./components/CustomerTable";
import { useUser } from "./hooks/useUser";
import SearchAndFilter from "./components/SearchAndFilter";
import SortControls from "./components/SortControls";
import Swal from "sweetalert2";
import CustomerModalAdd from "./components/CustomerModalAdd";
import PaginationControls from "../artikel/components/PaginationControls";

const UserPage = () => {
  const { validate } = useAuth();

  const [showAddUserModal, setShowAddUserModal] = useState(false);

  const {
    user,
    loading,
    error,
    alert,
    pagination,
    meta,
    hasNextPage,
    hasPreviousPage,
    goToPage,
    changeLimit,
    changeSort,
    toggleSortOrder,
    search,
    nextPage,
    previousPage,
    firstPage,
    lastPage,
    addUser,
    editUser,
    removeUser,
    updateOnActive,
    currentSortField,
    currentSortOrder,
    syncDataDokter,

    // Filter functions
    filters,
    updateStatusFilter,
    updateTypeFilter,
    updateRoleFilter,
    clearFilters,
  } = useUser();

  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    validate();
  }, []);

  // Fungsi untuk handle add user
  const handleAddUser = async (userData) => {
    try {
      // Panggil API untuk menambah user
      const result = await addUser(userData);

      if (!result.success) {
        throw new Error(
          result.error || result.message || "Gagal menambahkan user",
        );
      }

      return result;
    } catch (error) {
      throw error;
    }
  };

  const handleEditUser = (user) => {
    console.log("Edit user:", user);
  };

  const handleDeleteUser = async (user) => {
    try {
      // Panggil API untuk menambah user
      const result = await removeUser(user);

      // if (!result.success) {
      //   throw new Error(
      //     result.error || result.message || "Gagal menambahkan user",
      //   );
      // }

      return result;
    } catch (error) {
      throw error;
    }
  };

  const handleUpdateOnActive = (user) => {
    console.log("Update on active:", user);
  };

  // Handle pagination
  const handlePageChange = useCallback(
    (page) => {
      goToPage(page);
    },
    [goToPage],
  );

  const handleLimitChange = useCallback(
    (limit) => {
      changeLimit(limit);
    },
    [changeLimit],
  );

  const handleViewUser = (data) => {
    console.log("Show modal add detail for user:", data);
  };

  const handleSort = useCallback(
    (field) => {
      toggleSortOrder(field);
    },
    [toggleSortOrder],
  );

  const handleClearFilters = useCallback(() => {
    clearFilters();
    setSearchTerm("");
    search("");
  }, [clearFilters, search]);

  const selectedRole = filters.role;

  const handleRoleChange = useCallback(
    (role) => {
      updateRoleFilter(role);
    },
    [updateRoleFilter],
  );

  const handleSearch = useCallback(
    (e) => {
      e.preventDefault();
      search(searchTerm);
    },
    [searchTerm, search],
  );

  const handleSearchChange = useCallback((value) => {
    setSearchTerm(value);
  }, []);

  // Fungsi untuk menampilkan pilihan
  const showUserOptions = () => {
    Swal.fire({
      title: "Pilih Tindakan",
      html: `
        <div style="display: flex; flex-direction: column; gap: 10px; padding: 10px;">
          <button id="btn-add-user" class="swal-btn swal-btn-primary" style="width: 100%; padding: 12px; border: none; border-radius: 8px; background: #28a745; color: white; font-size: 16px; cursor: pointer; transition: all 0.3s;" onmouseover="this.style.background='#218838'" onmouseout="this.style.background='#28a745'">
            <i class="fas fa-user-plus" style="margin-right: 8px;"></i> Tambah User Baru
          </button>
          <button id="btn-sync-doctor" class="swal-btn swal-btn-info" style="width: 100%; padding: 12px; border: none; border-radius: 8px; background: #17a2b8; color: white; font-size: 16px; cursor: pointer; transition: all 0.3s;" onmouseover="this.style.background='#138496'" onmouseout="this.style.background='#17a2b8'">
            <i class="fas fa-sync-alt" style="margin-right: 8px;"></i> Sync Akun Dokter
          </button>
        </div>
      `,
      showConfirmButton: false,
      showCloseButton: true,
      customClass: {
        popup: "swal-wide-popup",
        closeButton: "swal-close-btn",
      },
      didOpen: () => {
        // Event listener untuk tombol Tambah User
        const addUserBtn = document.getElementById("btn-add-user");
        if (addUserBtn) {
          addUserBtn.addEventListener("click", () => {
            Swal.close();
            // handleAddUser();
            setShowAddUserModal(true);
          });
        }

        // Event listener untuk tombol Sync Dokter
        const syncDoctorBtn = document.getElementById("btn-sync-doctor");
        if (syncDoctorBtn) {
          syncDoctorBtn.addEventListener("click", () => {
            Swal.close();
            handleSyncDoctor();
          });
        }
      },
    });
  };

  // Fungsi untuk Sync Akun Dokter
  const handleSyncDoctor = () => {

    Swal.fire({
      title: "Menyinkronkan...",
      html: "Sedang menyinkronkan akun dokter",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
        syncDataDokter()
          .then((result) => {
            if (result.success) {
              // Simulasi proses sync
              setTimeout(() => {
                Swal.fire({
                  icon: "success",
                  title: "Sinkronisasi Berhasil",
                  text: "Akun dokter berhasil disinkronkan",
                  timer: 2000,
                  showConfirmButton: false,
                });
              }, 2000);
            } else {
              Swal.fire({
                icon: "error",
                title: "Sinkronisasi Gagal",
                text: result.error || "Gagal menyinkronkan akun dokter",
              });
            }
          })
          .catch(() => {
            Swal.fire({
              icon: "error",
              title: "Sinkronisasi Gagal",
              text: "Terjadi kesalahan saat menyinkronkan akun dokter",
            });
          });
      },
    });
  };

  return (
    <>
      <NavbarComp />
      <AlertMessage
        show={alert.show}
        variant={alert.variant}
        message={alert.message}
        onClose={() => {}}
      />
      <Container fluid className="mt-2 mt-md-5">
        {/* HANYA SATU TOMBOL - Yang lainnya sudah dihapus */}
        <div className="d-flex gap-2">
          <Button
            variant="outline-success"
            className="mb-2"
            onClick={showUserOptions}
            title="Tambah User / Sync Dokter"
          >
            <IoAddCircleOutline size={32} />
            <span className="ms-2 d-none d-md-inline">Tambah / Sync</span>
          </Button>
        </div>

        <Card className="border-0 shadow-sm mb-4">
          <Card.Body>
            <SearchAndFilter
              searchTerm={searchTerm}
              selectedRole={selectedRole}
              onSearchChange={handleSearchChange}
              onSearchSubmit={handleSearch}
              onRoleChange={handleRoleChange}
              onClearFilters={handleClearFilters}
            />
          </Card.Body>
        </Card>

        {/* Sort Controls Card */}
        <Card className="border-0 shadow-sm mb-4">
          <Card.Body>
            <SortControls
              currentSortField={currentSortField}
              currentSortOrder={currentSortOrder}
              onSortChange={handleSort}
            />
          </Card.Body>
        </Card>

        <Card className="border-0 shadow-sm">
          <Card.Body>
            <CustomerTable
              user={user}
              loading={loading}
              error={error}
              pagination={pagination}
              meta={meta}
              currentSortField={currentSortField}
              currentSortOrder={currentSortOrder}
              onSort={handleSort}
              onEdit={handleEditUser}
              onDelete={handleDeleteUser}
              onView={handleViewUser}
            />

            {!loading && !error && user.length > 0 && (
              <PaginationControls
                pagination={pagination}
                meta={meta}
                hasNextPage={hasNextPage}
                hasPreviousPage={hasPreviousPage}
                onPageChange={handlePageChange}
                onLimitChange={handleLimitChange}
                onFirstPage={firstPage}
                onLastPage={lastPage}
                onNextPage={nextPage}
                onPreviousPage={previousPage}
              />
            )}
          </Card.Body>
        </Card>
      </Container>

      <CustomerModalAdd
        show={showAddUserModal}
        handleClose={() => setShowAddUserModal(false)}
        handleAddUser={handleAddUser}
      />
    </>
  );
};

export default UserPage;
